import { GET_BREAKING_EVENTS_DETAILS } from "./actions.type";
import { SET_BREAKING_EVENTS_DETAILS } from "./mutations.type";

const STATE = {
  details: {
    title: null,
    feature: null,
  },
};

const GETTERS = {
  details: (state) => state.details,
};

const ACTIONS = {
  [GET_BREAKING_EVENTS_DETAILS](context, data) {
    if (data && data.feature) {
      context.commit(SET_BREAKING_EVENTS_DETAILS, data);
    }
    return Promise.resolve(true);
  },
};

const MUTATIONS = {
  [SET_BREAKING_EVENTS_DETAILS](state, data) {
    state.details = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
